import { mapGetters } from "vuex";

export const reorderPageHelper = {
  computed: {
    ...mapGetters({
      favoriteProducts: "favoriteProductsState",
    }),
  },
  methods: {
    mapReorderToVariantList: function (reorder) {
      return reorder.suborder?.items?.map((variant) => {
        const {
          product_image,
          product_name,
          characteristic_option_map,
          original_quantity,
          product_id,
          variant_id,
          track_inventory,
          in_stock,
          inventory_quantity,
          wholesale_increament,
          wholesale_minimum,
          price,
          is_variant_deleted,
        } = variant;

        const variantName = Object.keys(characteristic_option_map)
          .map((group) => {
            return this.$utils.displayCharacteristicOption(group, characteristic_option_map[group]);
          })
          .join(" ");
        return {
          image: product_image,
          productName: product_name,
          originalQuantity: original_quantity,
          isFavorite: this.favoriteProducts?.includes(product_id),
          productId: product_id,
          variantId: variant_id,
          trackInventory: track_inventory,
          inStock: in_stock,
          inventoryQuantity: inventory_quantity,
          increment: wholesale_increament,
          minimum: wholesale_minimum,
          deleted: is_variant_deleted,
          price,
          variantName,
        };
      });
    },
  },
};
